import React from 'react';

function DashboardsSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#00253E"
        d="M21.348 0H2.652A2.656 2.656 0 000 2.653v13.512a2.656 2.656 0 002.652 2.653h6.11V22.2H6.157a.9.9 0 000 1.8h11.685a.9.9 0 000-1.8h-2.606v-3.382h6.11A2.655 2.655 0 0024 16.165V2.653A2.654 2.654 0 0021.348 0zM2.652 1.8h18.696c.47 0 .852.383.852.853v9.583H1.8V2.653c0-.47.383-.853.852-.853zm10.784 20.4h-2.872v-3.382h2.874V22.2h-.002zm7.912-5.182H2.652a.853.853 0 01-.852-.853v-2.127h20.4v2.127c0 .47-.383.853-.852.853z"
      ></path>
    </svg>
  );
}

export default DashboardsSvg;
